import React from "react";
import { CircleMarker, Marker } from "react-leaflet";

export default React.memo(({ val, icon, onClick, hidden }) => {
  if (hidden) return null;
  return (
    <CircleMarker
      center={[val.latitude, val.longitude]}
      radius={5}
      eventHandlers={{
        click: () => onClick(val),
      }}
    />
    // <Marker
    //   position={[val.latitude, val.longitude]}
    //   icon={icon}
    //   rotationAngle={val.direction}
    //   eventHandlers={{
    //     click: () => onClick(val),
    //   }}
    // />
  );
});
